<template>
    <v-dialog v-model="dialog" max-width="500px">
        <v-card>
            <v-card-title
                class="text-h5 aviso"
                style="
                    justify-content: center;
                    background: #1d2735;
                    color: white;
                "
            >
                Enviar aviso nuevo presupuesto
            </v-card-title>
            <v-card-text style="text-align: center">
                <v-row justify="center" style="padding-top: 1rem">
                    <v-col cols="10" md="6">
                        <v-autocomplete
                            outlined
                            v-model="producto"
                            :items="lista_productos"
                            item-text="nombre"
                            item-value="id"
                            label="Producto"
                        >
                        </v-autocomplete>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="pt-3">
                <v-spacer></v-spacer>

                <v-btn color="error" large @click="dialog = false"
                    >Cancelar</v-btn
                >
                <v-btn color="success" large @click="enviar()">Confirmar</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props: ["value", "id_cliente", "id_producto", "productos"],
    data() {
        return {
            dialog: false,
            producto: false,
            lista_productos: [],
        };
    },
    created() {
        this.init();
    },
    watch: {
        value() {
            this.init();
        },
        id_producto() {
            this.init();
        },
        productos(val) {
            if (val != null) {
                this.lista_productos = val;
            }
        },
        dialog(val) {
            this.$emit("input", val);
        },
    },
    methods: {
        init() {
            if (this.value != null) {
                this.dialog = this.value;
            }
            if (this.id_producto != null) {
                this.producto = this.id_producto;
            }
            if (this.productos) {
                this.lista_productos = this.productos;
            }
            if (
                this.dialog == true &&
                (this.lista_productos?.length ?? 0) == 0
            ) {
                axios.get(`api/get-productos-interes`).then(
                    (res) => {
                        this.lista_productos = res.data;
                    },
                    (res) => {}
                );
            }
        },
        enviar() {
            if (this.id_cliente == null && this.id_producto == null) return;
            axios
                .post("api/cliente-producto-mail", {
                    id_cliente: this.id_cliente,
                    id_producto: this.producto,
                })
                .then((res) => {
                    this.dialog = false;
                    this.$toast.sucs("Aviso enviado con éxito");
                });
        },
    },
};
</script>
